export function initPrefooter() {
  cardExpandCollapse();
  expandCloseAccordionWrapper();
}

export async function initPrefooterModal() {
  let preFooterFullButton = document.querySelector('.pre-footer-full');
  preFooterFullButton.addEventListener('click', createPrefooterModal);
}

let cardElementsHidden = document.querySelectorAll('.accordion-sText .card.hiding');
let accordionElementElipsis = document.querySelector('.accordion-sText .accordion-sText-wrapper');
let accordionExpandBtn = document.querySelector('.accordion-sText .accordion-sText-wrapper-btn-expand');
let accordionCloseBtn = document.querySelector('.accordion-sText .accordion-sText-wrapper-btn-collapse');

function cardExpandCollapse() {
  for (let i = 0; i < cardElementsHidden.length; i++) {
    cardElementsHidden[i].addEventListener('click', function () {
      cardsCollapse();
      if (cardElementsHidden[i].querySelector('.card-header')) {
        cardElementsHidden[i].classList.add('active');
      }
    });
  }
}

function cardsCollapse() {
  [].forEach.call(cardElementsHidden, function (el) {
    el.classList.remove('active');
  });
}

function expandCloseAccordionWrapper() {
  accordionExpandBtn?.addEventListener('click', function () {
    accordionElementElipsis.classList.add('active');
  });
  accordionCloseBtn?.addEventListener('click', function () {
    if (accordionElementElipsis.classList.contains('active')) {
      accordionElementElipsis.classList.remove('active');
    }
  });
}

let createPrefooterModal = async () => {
  let modalPrefooterEl = document.querySelector('.modal-prefooter');
  if (!modalPrefooterEl) {
    const { default: ModalPrefooter } = await import('../classes/modalPrefooter.js');
    let modalPrefooter = new ModalPrefooter({
      mainClass: 'modal-prefooter',
      additionalClasses: 'prefooter',
      containerClass: 'modals',
      containerSelector: '.modals'
    });
    modalPrefooter.setVisible(true);
    document.body.classList.add('modal-open');
  } else {
    modalPrefooterEl.classList.add('active');
    document.body.classList.add('modal-open');
  }

  cardElementsHidden = document.querySelectorAll('.accordion-sText .card.hiding');
  accordionElementElipsis = document.querySelector('.accordion-sText .accordion-sText-wrapper');
  accordionExpandBtn = document.querySelector('.accordion-sText .accordion-sText-wrapper-btn-expand');
  accordionCloseBtn = document.querySelector('.accordion-sText .accordion-sText-wrapper-btn-collapse');

  initPrefooter();
};
